import axios from '@/util/axios'
import { NEW_API_CONFIG } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * お知らせカテゴリ一覧API
 * @param  {} params={}
 */
export const listCategories = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IN/001', r).catch(handleError)
}
// TODO:共通処理のマスター取得利用に切り替わったので、後で削除

/**
 * お知らせ一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IN/002', r).catch(handleError)
}

/**
 * お知らせ詳細API
 * @param  {} params={}
 */
export const detail = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IN/003', r).catch(handleError)
}
